import React, {useContext} from "react";
import InvoiceList from "../../../components/pages/invoices/InvoiceList";
import SubMenu from "../../../components/SubMenu";
import { DataTablePreferenceContext } from "../../../components/DataTablePreferenceProvider";
import AppLayout from "../../../components/layouts/AppLayout";

function SentInvoices(props) {
    const dataTablePreferenceCtx = useContext(DataTablePreferenceContext);
    const InvoicesTabMenu = [
        { label: 'Unpaid', href: '/invoices/sent', regExp: /^\/invoices\/sent(\?.*)?(\#.*)?$/ },
        { label: 'Closed', href: '/invoices/sent/closed', regExp: /^\/invoices\/sent\/closed(\?.*)?(\#.*)?$/  },
        { label: 'All', href: '/invoices/sent/all', regExp: /^\/invoices\/sent\/all(\?.*)?(\#.*)?$/  }
    ];
    const { status, children } = props;
    dataTablePreferenceCtx.updatePreferences({table: 'invoices', key: 'activeTab', value: status});

    return (
        <AppLayout title="Invoices" contentTitle="Sent" hasStickyDesktopPageHeader>
            <SubMenu items={InvoicesTabMenu} margin={{top: 'small'}}/>
            <InvoiceList 
                dataName="invoices" 
                status={status || 'unpaid'} 
                dataTableWrapperProps={{margin: "none"}}/>
        </AppLayout>
    );
}

export default SentInvoices;
